module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-template-selection"
  }, [(!_vm.loading) ? _c('b-tabs', {
    attrs: {
      "small": ""
    },
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, _vm._l((_vm.tagGroups), function(tagGroup) {
    return _c('b-tab', {
      key: tagGroup.id,
      attrs: {
        "title": tagGroup.name
      }
    }, [_c('div', {
      staticClass: "template-list"
    }, _vm._l((tagGroup.templates), function(template) {
      return _c('div', {
        key: template.PKM_Template,
        staticClass: "_entry-wrap_",
        on: {
          "click": function($event) {
            _vm.handleTemplateClick(template)
          }
        }
      }, [_c('b-card', {
        class: _vm.cardClasses(template),
        attrs: {
          "show-footer": ""
        }
      }, [_c('img', {
        staticClass: "image",
        attrs: {
          "src": _vm.getAbsolutePathForImage(template.S_Vorschaubild_url),
          "alt": template.S_Titel
        }
      }), _vm._v(" "), _c('small', {
        staticClass: "text-muted",
        attrs: {
          "title": template.S_Template
        },
        slot: "footer"
      }, [_c('span', {
        staticClass: "_tmpl-id"
      }, [_vm._v(_vm._s(template.PKM_Template))]), _vm._v(" "), _c('span', {
        staticClass: "_tmpl-name"
      }, [_vm._v(_vm._s(template.S_Titel))]), _vm._v(" "), _c('div', {
        staticClass: "_tmpl-tags"
      }, _vm._l((template.tags.result), function(tag) {
        return _c('b-badge', {
          key: tag.PKM_Tag,
          staticClass: "badge"
        }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(tag.S_Value) + "\n\t\t\t\t\t\t\t\t")])
      }))])])], 1)
    }))])
  })) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('erco-cloak') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-044b6cd1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/ErcoSidebar/TemplateSelection.vue
// module id = 588
// module chunks = 0